import Glide from '@glidejs/glide';

const slider = new Glide('.slider__wrapper.glide', {
  perView: 1,
  type: 'carousel',
  autoplay: 5000,
  peek: 250,
  breakpoints: {
    1140: {
      peek: 0,
    },
  },
});
slider.mount();

/**
 * Code for the find care section
 */

const tab_buttons = document.querySelectorAll('[data-tab-button]');

tab_buttons.forEach((button) => {
  button.addEventListener('change', (e) => {
    const button_id = button.dataset.tabButton;
    document.querySelectorAll('[data-tab-content]').forEach((section) => {
      section.classList.add('find-care__hide');
    });
    document
      .querySelector(`[data-tab-content="${button_id}"]`)
      .classList.remove('find-care__hide');
  });
});
